import PropTypes from 'prop-types'
import { ReRegisterPageQuery, REREGISTER_QUERY } from '@layouts/reregister'
import { fetchSSRData } from '@lib/ssr-fetch'

function ReRegisterPage(props) {
  const { data: ssrData, ...restProps } = props
  return (
    <ReRegisterPageQuery {...restProps} ssrData={ssrData} />
  )
}

ReRegisterPage.propTypes = {
  data: PropTypes.object,
}

ReRegisterPage.getInitialProps = async ({ query }) => fetchSSRData({
  query,
  graphqlQuery: REREGISTER_QUERY,
  variables: { pageSlug: '/reregister' },
  transform: (data) => data?.associateProgramCollection?.items[0] || null,
})

export default ReRegisterPage
